import React, { useState } from "react";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { STATUS_OPTIONS } from "../utils/constants";

const OrderFilters = ({
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  showAllDates,
  setShowAllDates,
  status,
  setStatus,
  orderType,
  setOrderType,
  orderTypeOptions,
  search,
  setSearch,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="flex-1">
      {/* Collapsible Filter Header */}
      <div
        className="flex items-center justify-between mb-2 cursor-pointer p-2 bg-gray-50 rounded-md hover:bg-gray-100 transition-colors"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-2">
          <svg
            className={`w-3 h-3 text-gray-600 transition-transform ${isExpanded ? "rotate-90" : ""}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
          <h3 className="font-semibold text-xs text-gray-900">Filters</h3>
        </div>
        <span className="text-[10px] text-gray-500">
          {isExpanded ? "Hide" : "Show"}
        </span>
      </div>

      {/* Filter grid - Collapsible */}
      {isExpanded && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-1.5 mb-1.5">
          {/* FROM DATE */}
          <div>
            <label className="font-medium text-[10px] text-gray-700 mb-0.5 block">
              From Date
            </label>
            <div className="relative">
              <Calendar
                value={fromDate}
                onChange={(e) => setFromDate(e.value)}
                dateFormat="yy-mm-dd"
                disabled={showAllDates}
                showIcon
                className="w-full"
                inputClassName="text-xs bg-white border border-gray-200 rounded-md px-2 py-1 focus:ring-1 focus:ring-blue-500/20 focus:border-blue-400 transition-all placeholder:text-gray-400"
                placeholder="Select start date"
                panelClassName="shadow-md border-0 rounded-md overflow-hidden"
              />
            </div>
          </div>

          {/* TO DATE */}
          <div>
            <label className="font-medium text-[10px] text-gray-700 mb-0.5 block">
              To Date
            </label>
            <div className="relative">
              <Calendar
                value={toDate}
                onChange={(e) => setToDate(e.value)}
                dateFormat="yy-mm-dd"
                disabled={showAllDates}
                showIcon
                className="w-full"
                inputClassName="text-xs bg-white border border-gray-200 rounded-md px-2 py-1 focus:ring-1 focus:ring-blue-500/20 focus:border-blue-400 transition-all placeholder:text-gray-400"
                placeholder="Select end date"
                panelClassName="shadow-md border-0 rounded-md overflow-hidden"
              />
            </div>
          </div>

          {/* STATUS */}
          <div>
            <label className="font-medium text-[10px] text-gray-700 mb-0.5 block">
              Order Status
            </label>
            <div className="relative">
              <Dropdown
                value={status}
                options={STATUS_OPTIONS}
                onChange={(e) => setStatus(e.value)}
                placeholder="All Status"
                className="w-full"
                panelClassName="shadow-md border-0 rounded-md overflow-hidden bg-white"
                inputClassName="text-xs bg-white border border-gray-200 rounded-md px-2 py-1 focus:ring-1 focus:ring-blue-500/20 focus:border-blue-400 transition-all placeholder:text-gray-400 cursor-pointer"
                itemTemplate={(option) => (
                  <div className="px-2 py-1 hover:bg-blue-50 transition-colors text-xs">
                    {option.label}
                  </div>
                )}
                valueTemplate={(option, props) => (
                  <span className="text-xs text-gray-700">
                    {option ? option.label : props.placeholder}
                  </span>
                )}
              />
            </div>
          </div>

          {/* ORDER TYPE */}
          <div>
            <label className="font-medium text-[10px] text-gray-700 mb-0.5 block">
              Order Type
            </label>
            <div className="relative">
              <Dropdown
                value={orderType}
                options={orderTypeOptions}
                onChange={(e) => setOrderType(e.value)}
                placeholder="All Types"
                className="w-full"
                panelClassName="shadow-md border-0 rounded-md overflow-hidden bg-white"
                inputClassName="text-xs bg-white border border-gray-200 rounded-md px-2 py-1 focus:ring-1 focus:ring-blue-500/20 focus:border-blue-400 transition-all placeholder:text-gray-400 cursor-pointer"
                itemTemplate={(option) => (
                  <div className="px-2 py-1 hover:bg-blue-50 transition-colors text-xs">
                    {option.label}
                  </div>
                )}
                valueTemplate={(option, props) => (
                  <span className="text-xs text-gray-700">
                    {option ? option.label : props.placeholder}
                  </span>
                )}
              />
            </div>
          </div>

          {/* SEARCH */}
          <div>
            <label className="font-medium text-[10px] text-gray-700 mb-0.5 block">
              Search Orders
            </label>
            <div className="relative">
              <div className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none z-10">
                <svg
                  className="w-3 h-3"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>
              <InputText
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search by ID or Bill No or phone..."
                className="w-full bg-white border border-gray-200 rounded-md pl-7 pr-2 py-1 text-xs focus:ring-1 focus:ring-blue-500/20 focus:border-blue-400 transition-all placeholder:text-gray-400"
              />
            </div>
          </div>

          {/* Show All Dates Toggle */}
          <div className="col-span-full mt-1 pt-1 border-t border-gray-100">
            <div className="flex items-center gap-1.5 p-1 rounded-md bg-gray-50/50 hover:bg-gray-50 transition-colors">
              <Checkbox
                checked={showAllDates}
                onChange={(e) => setShowAllDates(e.checked)}
                className="text-blue-500"
              />
              <span className="font-medium text-[10px] text-gray-800">
                Show All Dates
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OrderFilters;
